<template>
  <div class="main-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="60px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="searchValue" label="关键字">
              <el-input
                v-model.trim="queryForm.searchValue"
                placeholder="请输入申请企业/申请人/联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" style="margin-right: 6px" @click="handleSearch"
              >搜索</el-button
            >
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="12">
            <el-button
              type="success"
              :loading="exportBtnLoading"
              style="float: right;"
              @click="handleExportLog"
              >{{ exportBtn }}</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table ref="tableRef" :data="trialUserList" v-loading="tableLoading" stripe border>
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="company"
          label="申请企业"
          align="center"
          width="300"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="industryName"
          label="所在行业"
          width="300"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="申请人"
          align="center"
          width="100"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="联系电话"
          align="center"
          width="150"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="position"
          label="职务"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="appName"
          label="申请试用系统"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="申请时间"
          align="center"
          :resizable="false"
        ></el-table-column>
      </el-table>
    </div>
    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import trialApi from 'api/home/users-trial.js';

export default {
  data() {
    return {
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        searchValue: ''
      },
      tableLoading: true,
      trialUserList: [],
      exportBtn: '导出数据',
      exportBtnLoading: false
    };
  },
  created() {
    this.getTrialUserListData();
  },
  methods: {
    // 获取试用用户列表
    getTrialUserListData() {
      this.tableLoading = true;
      trialApi
        .getTrialUserList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.trialUserList = res.data.data.rows;
          }
          this.tableLoading = false;

          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getTrialUserListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getTrialUserListData();
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getTrialUserListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.getTrialUserListData();
    },
    // 导出列表
    handleExportLog() {
      this.exportBtnLoading = true;
      this.exportBtn = '导出中...';
      console.log(this.queryForm);
      trialApi
        .getExport({ searchValue: this.queryForm.searchValue })
        .then(res => {
          console.log(res);
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          let h = JSON.stringify(res.headers);
          let j = JSON.parse(h);
          let fileName = decodeURI(j['content-disposition'].split('attachment; filename=')[1]);
          fileName = fileName.replace(/\"/g, '');
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          // debugger;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.exportBtnLoading = false;
          this.exportBtn = '导出数据';
          this.$message({
            type: 'success',
            message: '导出数据成功'
          });
        })
        .catch(err => {
          this.exportBtnLoading = false;
          this.exportBtn = '导出数据';
        });
    }
  }
};
</script>

<style lang="less" scoped>
.main-container {
  padding: 16px;

  .page {
    margin: 16px 0;
    float: right;
  }
}
</style>
